import { useEffect } from "react";

const GTM_ID = "GTM-KXQLR2WX";
const GA4_ID = "G-8EF6BTT9HJ";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

function loadScript(src: string) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

/**
 * Loads Google Tag Manager and GA4 after first paint so analytics never
 * competes with fonts, CSS or the hero image on the critical path.
 */
export function Analytics() {
  useEffect(() => {
    let done = false;
    const start = () => {
      if (done) return;
      done = true;

      window.dataLayer = window.dataLayer || [];
      const gtag = (...args: unknown[]) => {
        window.dataLayer!.push(args);
      };

      window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      loadScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);

      loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`);
      gtag("js", new Date());
      gtag("config", GA4_ID);
    };

    const idle = (
      window as unknown as { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number }
    ).requestIdleCallback;

    const timer = window.setTimeout(start, 2500);
    if (idle) idle(start, { timeout: 3000 });
    else window.addEventListener("load", start, { once: true });

    return () => window.clearTimeout(timer);
  }, []);

  return null;
}
